import i18n from "i18next";
import { initReactI18next } from "react-i18next";
const messages: any = {};
const modules: any = import.meta.glob("./locales/*.ts", {
  eager: true,
});
Object.keys(modules).forEach(key => {
  const fileName = key.replace(/.*\/locales\/([^\/]*)*.ts/gi, "$1");
  messages[fileName] = {};
  messages[fileName]["translation"] = modules[key].default;
});
const langMap = {
  ...messages,
  // get localhost() {
  //   return this["en"];
  // },
  // get "test.comfortweather.com"() {
  //   return this["en"];
  // },
  // 英语域名
  get "en-v-ls.comfortweather.com"() {
    return this["en"];
  },
  // 泰语域名
  get "th-v-ls.comfortweather.com"() {
    return this["th"];
  },
  // 印尼语域名
  get "id-v-ls.comfortweather.com"() {
    return this["id"];
  },

  // 美国
  get "en-mxwg.comfortweather.com"() {
    return this["en"];
  },
  // 墨西哥
  get "es-mxwg.comfortweather.com"() {
    return this["es"];
  },

  // 印地语域名
  get "hi-v-ls.comfortweather.com"() {
    return this["hi"];
  },
  // 越南语域名
  get "vi-v-ls.comfortweather.com"() {
    return this["vi"];
  },
  // 小米天气的小部件英文域名
  get "en-miwg.comfortweather.com"() {
    return this["en"];
  },
  // 小米印地语域名
  get "hi-miwg.comfortweather.com"() {
    return this["hi"];
  },
  // 小米印尼语域名
  get "id-miwg.comfortweather.com"() {
    return this["id"];
  },

  // 巴西葡萄牙语
  get "pt-br-mils.comfortweather.com"() {
    return this["pt"];
  },
  // 欧洲-葡萄牙语
  get "pt-mils.comfortweather.com"() {
    return this["pt-pt"];
  },
  // 西班牙语
  get "es-mils.comfortweather.com"() {
    return this["es"];
  },

  // 阿拉伯语
  get "arabic-mils.comfortweather.com"() {
    return this["ar"];
  },
  // 土耳其语
  get "tr-mils.comfortweather.com"() {
    return this["tr-tr"];
  },
  // 法语
  get "fr-mils.comfortweather.com"() {
    return this["fr-fr"];
  },
  // 意大利语
  get "it-mils.comfortweather.com"() {
    return this["it-it"];
  },
  // 乌尔都语
  get "urdu-mils.comfortweather.com"() {
    return this["ur"];
  },
  // 越南语
  get "vi-mils.comfortweather.com"() {
    return this["vi"];
  },
  // 泰语
  get "th-mils.comfortweather.com"() {
    return this["th"];
  },
  // 英语
  get "en-mils.comfortweather.com"() {
    return this["en"];
  },
  // 日语
  get "jp-mils.comfortweather.com"() {
    return this["ja-jp"];
  },
  // 德语
  get "ger-mils.comfortweather.com"() {
    return this["de-de"];
  },
  // 印尼语
  get "id-mils.comfortweather.com"() {
    return this["id"];
  },
  // 波兰语
  get "po-mils.comfortweather.com"() {
    return this["pl-pl"];
  },
  // 印尼语
  get "id-wi.comfortweather.com"() {
    return this["id"];
  },
  // 西班牙语
  get "es-wi.comfortweather.com"() {
    return this["es"];
  },
  // 英语域名
  get "en-wg.comfortweather.com"() {
    return this["en"];
  },
  // 印地语域名
  get "hi-wg.comfortweather.com"() {
    return this["hi"];
  },
  // 印尼语域名
  get "id-wg.comfortweather.com"() {
    return this["id"];
  },
  // 西班牙语域名
  get "es-wg.comfortweather.com"() {
    return this["es"];
  },

  // 孟加拉语
  get "bn-mils.comfortweather.com"() {
    return this["bn-bd"];
  },

  // 希腊语
  get "el-mils.comfortweather.com"() {
    return this["el-gr"];
  },

  // 希伯来语
  get "he-mils.comfortweather.com"() {
    return this["he"];
  },

  // 韩语
  get "ko-mils.comfortweather.com"() {
    return this["ko"];
  },

  // 乌克兰语
  get "uk-mils.comfortweather.com"() {
    return this["uk"];
  },

  // 缅甸语
  get "my-mils.comfortweather.com"() {
    return this[""];
  },

  // 俄语
  get "ru-mils.comfortweather.com"() {
    return this["ru-ru"];
  },

  // 阿塞拜疆语
  get "az-mils.comfortweather.com"() {
    return this["az-latn-az"];
  },

  // 匈牙利语
  get "hu-mils.comfortweather.com"() {
    return this["hu-hu"];
  },

  // 罗马尼亚语
  get "ro-mils.comfortweather.com"() {
    return this["ro-ro"];
  },

  // 塞尔维亚语
  get "sr-mils.comfortweather.com"() {
    return this["sr-rs"];
  },

  // 保加利亚语
  get "bg-mils.comfortweather.com"() {
    return this["bg"];
  },

  // 斯洛伐克语
  get "sk-mils.comfortweather.com"() {
    return this["sk"];
  },

  // 繁体中文
  get "zh-hant-mils.comfortweather.com"() {
    return this["zh-hant"];
  },
  // 僧伽罗语
  get "si-mils.comfortweather.com"() {
    return this["si"];
  },
  // 捷克语
  get "cs-mils.comfortweather.com"() {
    return this["cs"];
  },
};
const localeMap = Object.keys(langMap);
const langKey = Object.keys(messages);
const { lan } = useLanguage();
i18n.use(initReactI18next).init({
  lng: localeMap.includes(window.location.hostname)
    ? window.location.hostname
    : langKey.includes(lan)
    ? lan
    : `${lan}.comfortweather.com`,
  debug: isDevEnv ? true : false,
  interpolation: {
    escapeValue: false,
  },
  resources: langMap,
});

export { langMap, localeMap, langKey };
export default i18n;

/*
// 日期和数字格式化
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
function DateDisplay() {
  const { i18n } = useTranslation();
  const date = DateTime.now().setLocale(i18n.language).toLocaleString(DateTime.DATE_FULL);
  return <div>{date}</div>;
}
*/

/*
  // 3秒后修改语言
  const { i18n } = useTranslation();
  const timer = setTimeout(() => {
    clearTimeout(timer);
    i18n.changeLanguage("en");
  }, 3000);
  */
